interface PercentBarProps {
    percent: number;
}

const PercentBar = ({ percent }: PercentBarProps) => {
    const color =
        percent >= 75 ? 'bg-green-500' :
        percent >= 50 ? 'bg-yellow-400' :
        'bg-red-400';

    return (
        <div className="flex items-center gap-2 min-w-[100px]">
            <div className="flex-1 h-2 rounded-full bg-muted overflow-hidden">
                <div
                    className={`h-full rounded-full ${color}`}
                    style={{ width: `${Math.min(100, Math.max(0, percent))}%` }}
                />
            </div>
            <span className="text-xs w-8 text-right">{Math.round(percent)}%</span>
        </div>
    );
};

export default PercentBar;
